// extracted by mini-css-extract-plugin
export var sectionTitle = "SidebarContent-module--sectionTitle--aea43";